import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import SearchFilters from '../../../../components/elements/SearchFilter';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useLocation } from 'react-router-dom';
import { PageHitCountApi } from '../../../../shared/Helper';

import { printTable } from '../../../../utils/tableExportUtils';
const GWARegisterApprovalList = () => {
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [next, setNext] = useState(1);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [order, setOrder] = useState(0);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageCondition, setPageCondition] = useState({
    page: 0,
    currentPage: 0,
  });
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const pageCount = Math.ceil(totalPages / recordsPerPage);
  const { pathname } = useLocation()


  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])

  // const sortedData = React.useMemo(() => {
  //   let sortableItems = [...apiData];
  //   if (sortConfig !== null) {
  //     sortableItems.sort((a, b) => {
  //       const dateA = moment(a[sortConfig.key], 'DD/MM/YYYY').toDate();
  //       const dateB = moment(b[sortConfig.key], 'DD/MM/YYYY').toDate();
  //       if (dateA < dateB) {
  //         return sortConfig.direction === 'ascending' ? -1 : 1;
  //       }
  //       if (dateA > dateB) {
  //         return sortConfig.direction === 'ascending' ? 1 : -1;
  //       }
  //       return 0;
  //     });
  //   }
  //   return sortableItems;
  // }, [apiData, sortConfig]);
  const SearchFilter = {
    epUserID: 0,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    order: order,
  };
  const getData = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(`GWAService/GetGWAServiceApprovalFilterList/${currentPage}/${recordsPerPage}`, SearchFilter)
      .then((response) => {
        setIsLoad(false);
        setPageCondition({
          ...pageCondition,
          page: response.page,
          currentPage: response.currentPage,
        });
        setTotalPages(response.data[0]?.pageCount);
        setApiData(response.data);
        setNext(currentPage);

        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    getData();
  }, [order]);

  const changePage = async ({ selected }) => {
    var select = selected + 1;
    await postAsync('GWAService/GetGWAServiceApprovalFilterList/' + select + '/' + recordsPerPage, SearchFilter, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setApiData(response.data);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      Name: item.fullName,
      Date: item.date,
      Time: item.timeNow,
      // 'Item Level': item.menuLevelID,
      Status:
        item?.maApproveID === 0
          ? t('Pending')
          : item?.maApproveID === 1
            ? t('Approved')
            : item?.maApproveID === 2
              ? t('Disapproved')
              : 'N/A',
    }));

    downloadCSV(filteredData, 'Goodwill Ambassador Registration Approval List');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Goodwill Ambassador Registration Approval List')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Name')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Date')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Time')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Status')}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.fullName || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date || 'N/A'}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${
  //               data?.maApproveID === 0
  //                 ? t('Pending')
  //                 : data?.maApproveID === 1
  //                   ? t('Approved')
  //                   : data?.maApproveID === 2
  //                     ? t('Disapproved')
  //                     : 'N/A'
  //             }</td>

  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);
  //   window.print();
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Name'),
      accessor: (row) => isActive ? row?.fullName : row?.fullName
    },
     {
      header: t('Date'),
      accessor: (row) => isActive ? row?.date : row?.date
    },   {
      header: t('Time'),
      accessor: (row) => isActive ? row?.timeNow || 'N/A' : row?.timeNow  || 'N/A'
    },  {
  header: t('Status'),
  accessor: (row) =>
    !isActive
      ? 'N/A'
      : row?.maApproveID === 0
        ? t('Pending')
        : row?.maApproveID === 1
          ? t('Approved')
          : row?.maApproveID === 2
            ? t('Disapproved')
            : 'N/A'
}


  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Goodwill Ambassador Registration Approval List')}`,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  return (
    <>
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="container-fluid ">
            {/* <div className="row justify-center">
              <div className="col-lg-11 text-center">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">
                  {t('Registration Approval')} {t('list')}
                </h3>
              </div>
            </div> */}
            <div className="row   justify-center   py-5 mt-3">
              <SearchFilters
                handleSearch={getData}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Registration Approval List'}
              />
              <div className="col-lg-11 text-center pt-9">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="relative overflow-x-auto  shadow-md sm:rounded-lg">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="font-bold text-white bg-customgreen uppercase ">
                        <Table.Row className="items-center">
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('sNo')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Name')}
                          </Table.HeaderCell>
                          <Table.HeaderCell
                            className="text-white  cursor-pointer  items-center align-middle"
                            onClick={() => {
                              setOrder(order == 0 ? 1 : 0);
                            }}
                          >
                            {t('Date')}

                            {order ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Time')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Status')}
                          </Table.HeaderCell>
                          <Table.HeaderCell className="text-white items-center align-middle">
                            {t('Detail')}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {apiData?.map((data, index) => {
                          const sno = (next - 1) * recordsPerPage + index + 1;
                          return (
                            <Table.Row key={index}>
                              <Table.Cell>{sno}</Table.Cell>
                              <Table.Cell>{data?.fullName}</Table.Cell>
                              <Table.Cell>{data?.date}</Table.Cell>
                              <Table.Cell>{data?.timeNow}</Table.Cell>
                              <Table.Cell>
                                {t(
                                  `${
                                    data?.maApproveID === 0
                                      ? 'Pending'
                                      : data?.maApproveID === 1
                                        ? 'Approved'
                                        : data?.maApproveID === 2
                                          ? 'Disapproved'
                                          : 'N/A'
                                  }`,
                                )}
                              </Table.Cell>
                              <Table.Cell>
                                <Link to={`/GWARegisterApproval/${data?.gwaServiceID}`}>
                                  <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
                                    <VisibilityOutlinedIcon />
                                  </button>
                                </Link>
                              </Table.Cell>
                            </Table.Row>
                          );
                        })}
                      </Table.Body>
                    </Table>
                    {datanotfound && <DataNotFound />}
                  </div>
                )}
                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between">
                    <Menu pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GWARegisterApprovalList;
